import styled from "styled-components";

import { hiddenButReaderAccessibleMixin } from "./mixins";

const ScreenReaderText = styled.span`
  ${hiddenButReaderAccessibleMixin};
`;

export default ScreenReaderText;
